import React from 'react';
import { GreenroomState } from '../../../../stores/types/types';
import { useDispatch, useSelector, } from 'react-redux';
import {addContentTemplate, 
    GeneratedContent, 
    StylePacksTypes, 
    updateContentTemplate, 
    Providers, 
    convertCapsuleVariablesToApi, 
    CapsuleItem,
    StylepackGroups,
    getContentTemplatesOfGroup,
} from './titles-add-utils';
import { loadGenerateContentTemplates } from '../../../../stores/actions/generate-content';
import GeneratedContentTemplates from './generated-templates';



const DebugAddStylePack: React.FC = () => {

    const{generatedContent} = useSelector((state: GreenroomState) => state.GeneratedContentReducer);
    const {contentTemplates} = useSelector((state: GreenroomState) => state.GeneratedContentReducer);
    const {media} = useSelector((state: GreenroomState) => state.MediaReducer);
    const {graphics}= useSelector((state: GreenroomState) => state.GraphicsReducer);
    const {token} = useSelector((state: GreenroomState) => state.SessionReducer);
    const [showListOfGeneratedContent, setShowListOfGeneratedContent] = React.useState<boolean>(false);
    const [showListOfTemplates, setShowListOfTemplates] = React.useState<boolean>(false);
    const [stylepackGroup, setStylepackGroup] = React.useState<string>(StylepackGroups.ACADEMY);


    const dispatch = useDispatch();
    const downloadFile = async (url: string | undefined, filename: string) => {
        if (!url) {
            console.error('No URL provided for download');
            return;
        }
        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`Failed to fetch ${filename}`);
            }
            const blob = await response.blob();
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error downloading file:', error);
        }
    };

    const AddGeneratedContentForm = () => {

        return (
            <>
            <h2>Add Generated Content Template</h2>
            <form onSubmit={async (e: React.FormEvent<HTMLFormElement>) => {
                e.preventDefault();
                const formData = new FormData(e.target as HTMLFormElement);
                if (!e.currentTarget.checkValidity()) {
                    console.error('Form is not valid');
                    return;
                }
                const newTemplate: GeneratedContent = {
                    provider: Providers.CAPSULE,
                    type: formData.get('type') as string,
                    name: formData.get('name') as string,
                    data: convertCapsuleVariablesToApi(JSON.parse(formData.get('data') as string || '') as unknown as [CapsuleItem], formData.get('content_type') as StylePacksTypes),
                    content_type: formData.get('content_type') as StylePacksTypes,
                    locked: false,
                    thumbnail_url:`ASSET_URL/title_templates/placeholder/thumbs/placeholder.jpg`,
                    video_url: `ASSET_URL/title_templates/placeholder/placeholder.mp4`,
                    style_pack: formData.get('style_pack') as string,
                };
                await addContentTemplate(newTemplate, token as string);
                if (token) dispatch(loadGenerateContentTemplates(token));
            }}>
                <h1>Template</h1>
                <div>
                    <label htmlFor="type">Type (the template name that is called in capsule api: e.g. api-brandlive-academy-speaker)</label>
                    <input type="text" name="type" required />
                </div>
                <div>
                    <label htmlFor="content_type">Content Type</label>
                    <select name="content_type" defaultValue={StylePacksTypes.TITLE} required>
                        <option value={StylePacksTypes.TITLE}>Title</option>
                        <option value={StylePacksTypes.WALKUP}>Walkup</option>
                        <option value={StylePacksTypes.SEGMENT}>Segment</option>
                        <option value={StylePacksTypes.COUNTDOWN}>Countdown</option>
                        <option value={StylePacksTypes.BOOKEND}>Bookend</option>
                        <option value={StylePacksTypes.SLIDE}>Slide</option>
                        {/* Add other options as needed */}
                    </select>
                </div>
                <div>
                    <label htmlFor="name">Name (visible name in front end: e.g. Tic Tac Toe)</label>
                    <input type="text" name="name" required />    
                </div>
                <div>
                    <label htmlFor="data">Data</label>
                    <textarea name="data" required />    
                </div>
                <div>
                    <label htmlFor="style_pack">Style Pack (The group name for the style pack: e.g. brandlive-tic-tac-toe)</label>
                    <input type="text" name="style_pack" required />    
                </div>
                <div>
                    <label htmlFor="locked">Locked</label>
                    <input type="checkbox" name="locked" value="false" />
                </div>
                
                {process.env.REACT_APP_NODE_ENV === 'local' ? <></> : <div>
                    <label htmlFor="style_pack">This is not localhost</label>
                    <input type="checkbox" name="envcheck" value="false" required/>
                </div>}
                <button type="submit">Add Template</button>
            </form>
            </>
        )
    };

    const generatedContentTemplates = contentTemplates.map((content) => {
        return (
            <GeneratedContentTemplates key={content.id} content={content} token={token ?? ''} />
        )
    });

    const listOfGeneratedContent = generatedContent.map((content, index) => {
        const {fkTable} = content;
        let mediaItem;
        if(fkTable === 'gr_media') {
            const item = media.find((item: { id: number | undefined; }) => item.id === content.fkId);
            if(!item) {
                return null;
            }
            mediaItem = item;
        } else {
            const item = graphics.find((item) => item.id === content.fkId);
            if(!item) {
                return null;
            }
            mediaItem = item;
        }
        const {jobStatus} = content;
        const mediaUrl = mediaItem.images;
        const thumbnailUrl =  mediaItem.thumbnail_url;
        return (
        <li key={index}>
            <strong>{content.templateId}</strong> - {content.type}
            <div>{`Job Status: ${jobStatus}`}</div>
           <div>Main content: {mediaUrl}</div>
           <button onClick={() => downloadFile(mediaUrl, `${content.type}.${mediaUrl.split('.').pop()}`)}>Content URL</button>
           <div>Thumbnail: {thumbnailUrl} </div>
           <button onClick={() => downloadFile(thumbnailUrl, `${content.type}.${thumbnailUrl.split('.').pop()}`)}>Thumbnail URL</button>
           <button onClick={async () => {
                if(token) {
                    await updateContentTemplate(content.templateId,{thumbnail_url:thumbnailUrl, video_url:mediaUrl}, token);
                    dispatch(loadGenerateContentTemplates(token));
                }
            }}>UPDATE DEFAULT TEMPLATE <br/>VIDEO AND THUMB URLS TO CURRENT</button>
        </li>
    )});

    const downloadMigrationFile = async (style_pack:StylepackGroups) => {
        if(!token) {
            console.error('No token provided for download');
            return;
        }
        const data = await getContentTemplatesOfGroup(style_pack, token);
        const fileName = `${style_pack}.json`;
        const fileContent = JSON.stringify(data, null, 2);
        const blob = new Blob([fileContent], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    const DownloadComponent = () => {
        return (
            <div>
                <h2>Download Migration File</h2>
                <div>
                    <label htmlFor="style_pack">Template Groups</label>
                    <select name="style_pack" value={stylepackGroup} onChange={(e) => {
                        const selectedGroup = e.target.value as StylepackGroups;
                        setStylepackGroup(selectedGroup);
                    }}>
                        <option value={StylepackGroups.ACADEMY}>ACADEMY</option>
                        <option value={StylepackGroups.BACK_TO_SCHOOL}>BACK_TO_SCHOOL</option>
                        <option value={StylepackGroups.MONDRIAN}>MONDRIAN</option>
                        <option value={StylepackGroups.ROTHKO}>ROTHKO</option>
                        <option value={StylepackGroups.TICTACTOE}>TICTACTOE</option>
                        <option value={StylepackGroups.TOPO}>TOPO</option>
                        {/* Add other options as needed */}
                    </select>
                </div>
                <button onClick={()=>downloadMigrationFile(stylepackGroup as StylepackGroups)}>Download</button>
            </div>
        );
    }

    return (
        <>
            <div>
                <DownloadComponent></DownloadComponent>
                <h1>Adjust Style Packs</h1>
                <button onClick={() => setShowListOfGeneratedContent(!showListOfGeneratedContent)}>
                    {showListOfGeneratedContent ? 'Hide' : 'Show'} Generated Content
                </button>
                {showListOfGeneratedContent && <div>
                    <h2>Generated Content Media</h2>
                    <ul>
                        {generatedContent && listOfGeneratedContent}
                    </ul>
                </div>}
            </div>
            <div>
                <h1>Set type of generated content templates</h1>
                <button onClick={() => setShowListOfTemplates(!showListOfTemplates)}>
                    {showListOfTemplates ? 'Hide' : 'Show'} Generated Content Templates
                </button>
                {showListOfTemplates && <div>  
                    <h2>Generated Content Templates</h2>
                    <ul>
                        {generatedContentTemplates}
                    </ul>
                </div>}
            </div>
            <div>
                <h1>Add Stylepack</h1>
                <AddGeneratedContentForm />
            </div>
        </>
    );
};

export default DebugAddStylePack;
